import { z } from 'zod';
import i18n from '@/i18n';

export const signInOtpSchema = z.object({
    otpFirstChar: z
        .string()
        // @ts-ignore
        .min(1, i18n.t('otp_required')),
    otpSecondChar: z
        .string()
        // @ts-ignore
        .min(1, i18n.t('otp_required')),
    otpThirdChar: z
        .string()
        // @ts-ignore
        .min(1, i18n.t('otp_required')),
    otpFourthChar: z
        .string()
        // @ts-ignore
        .min(1, i18n.t('otp_required')),
});

export type SignInOtpType = z.infer<typeof signInOtpSchema>;
